"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var end2end_1 = require("@hudled/end2end");
var constants_1 = require("containers/TableMaker/constants");
var ordered_1 = require("utils/selectors/ordered");
var GoToDb_1 = __importDefault(require("./CellComponents/GoToDb"));
var MarkCompleted_1 = __importDefault(require("./CellComponents/MarkCompleted"));
var RequestReconciliation_1 = __importDefault(require("./CellComponents/RequestReconciliation"));
var ViewDoc_1 = __importDefault(require("./CellComponents/ViewDoc"));
var LG = constants_1.CellSize.LG, MD = constants_1.CellSize.MD, XS = constants_1.CellSize.XS, SM = constants_1.CellSize.SM;
var getObjectSize = function (obj) { return obj && Object.keys(obj).length; };
var tableConf = {
    headersMap: {
        name: 'Vendor',
        accountingProvider: 'Accounting',
        importMethods: '',
        hasFeeTxn: 'Fee Txn',
        hasTransfer: 'Transfer',
        balanceMismatch: 'Bal. Mismatch',
        failedInvsCount: 'Fail Invs',
        txnsWithInvoiceWithNoIdCount: 'No Xero Id',
    },
    config: {
        selector: ordered_1.selectPayouts,
        defaultSort: { key: 'created', order: 1 },
    },
    extractors: {
        payoutAmount: function (item) { var _a, _b; return ((_b = (_a = item.data) === null || _a === void 0 ? void 0 : _a.object) === null || _b === void 0 ? void 0 : _b.amount) && (item.data.object.amount / 100); },
        hasFeeTxn: function (item) { return item.feeBankTxnAccountingId ? 'Yes' : 'No'; },
        hasTransfer: function (item) { return item.transferAccountingId ? 'Yes' : 'No'; },
        failedInvsCount: function (item) { var _a; return getObjectSize((_a = item.paymentsSummary) === null || _a === void 0 ? void 0 : _a.failedInvs); },
        txnsWithInvoiceWithNoIdCount: function (item) { var _a; return getObjectSize((_a = item.paymentsSummary) === null || _a === void 0 ? void 0 : _a.txnsWithInvoiceWithNoId); },
    },
    cells: [
        { field: 'companyName', cell: { width: LG }, truncate: {}, footerAggregate: 'count' },
        {
            field: 'created', cell: { width: MD }, truncate: {}, renderField: function (ts) { return ts ? (0, end2end_1.getISODate)(new Date(ts * 1000)) : '-'; },
        },
        {
            field: 'payoutAmount', cell: { width: LG }, money: {}, renderField: function (amount) { return amount && (amount / 100); },
        },
        { field: 'hasFeeTxn', cell: { width: SM, textAlign: 'center' } },
        { field: 'hasTransfer', cell: { width: SM, textAlign: 'center' } },
        { field: 'balanceMismatch', cell: { width: MD }, money: {}, fallback: '-' },
        { field: 'failedInvsCount', cell: { width: SM, textAlign: 'right' }, fallback: '-', footerAggregate: 'sum' },
        { field: 'txnsWithInvoiceWithNoIdCount', cell: { width: SM, textAlign: 'right' }, fallback: '-', footerAggregate: 'sum' },
        { key: 'empty', cell: { width: XS / 2, isActionCell: true } },
        { key: 'reqReconciliation', cell: { width: LG, isActionCell: true }, renderComponent: RequestReconciliation_1.default },
        { key: 'empty2', cell: { width: XS / 2, isActionCell: true } },
        { key: 'goToDb', cell: { width: SM, isActionCell: true }, renderComponent: GoToDb_1.default },
        { key: 'viewDoc', cell: { width: SM, isActionCell: true }, renderComponent: ViewDoc_1.default },
        { key: 'markCompletion', cell: { width: MD, isActionCell: true }, renderComponent: MarkCompleted_1.default },
    ],
};
exports.default = tableConf;
